<template>
  <div>
    <div v-if="items && items.length > 0">
      <h2 class="m-2">Items in subcategory</h2>
      <div class="flex flex-col px-2">
        <div
          class="grid-items my-1 border border-gray-200 rounded-md px-4 h-20 grid w-full items-center"
        >
          <div></div>
          <div>
            <input
              type="text"
              class="regular bordered full"
              placeholder="nkr code"
              v-model="filters.nkrCode"
            />
          </div>
          <div>
            <input
              type="text"
              class="regular bordered full"
              placeholder="unificado"
              v-model="filters.unificado"
            />
          </div>
          <div>
            <input
              type="text"
              class="regular bordered full"
              placeholder="description"
              v-model="filters.description"
            />
          </div>
          <div></div>
        </div>
        <SubcategoryItem
          v-for="item in itemsFiltered"
          :key="`1-${item.unificado}`"
          :item="item"
          @relationDeleted="deletedRelation(item.relationId)"
        />
      </div>
    </div>
    <div
      class="loading h-60 flex justify-center items-center"
      v-else-if="loading"
    >
      <BaseSmallSpinner></BaseSmallSpinner>
    </div>
    <div v-else class="h-60 w-full flex justify-center items-center">
      <h2>This subcategory is empty</h2>
    </div>
  </div>
</template>
<script>
import { getItemsInCategory } from "@/api/store/CategoriesService.js";
import SubcategoryItem from "@/components/SubcategoryItem.vue";

export default {
  components: {
    SubcategoryItem
  },
  props: {
    subcategoryId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      filters: {
        nkrCode: "",
        description: "",
        unificado: ""
      }
    };
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(item => {
        let valid = true;
        if (
          this.filters.nkrCode != "" &&
          !item.nkrCode
            .replace(/[^0-9a-zA-Z]/g, "")
            .includes(this.filters.nkrCode.replace(/[^0-9a-zA-Z]/g, ""))
        ) {
          valid = false;
        }
        if (
          this.filters.unificado != "" &&
          !item.unificado
            .replace(/[^0-9a-zA-Z]/g, "")
            .includes(this.filters.unificado.replace(/[^0-9a-zA-Z]/g, ""))
        ) {
          valid = false;
        }
        if (
          this.filters.description != "" &&
          !item.description
            .toLowerCase()
            .replace(/[^0-9a-zA-Z]/g, "")
            .includes(
              this.filters.description
                .toLowerCase()
                .replace(/[^0-9a-zA-Z]/g, "")
            )
        ) {
          valid = false;
        }
        return valid;
      });
    }
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    deletedRelation(relationId) {
      this.items = this.items.filter(item => item.relationId !== relationId);
    },
    loadItems() {
      this.loading = true;
      getItemsInCategory(this.subcategoryId)
        .then(res => {
          this.items = res;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="postcss" scoped>
.grid-items {
  grid-gap: 10px;
  grid-template-columns: 100px 150px 150px 1fr 140px;
}
</style>
